import { Box, Grid, Skeleton } from '@mui/material';
import _ from 'lodash';
import { Outlet, useLocation } from 'react-router-dom';
import { useGetSignedInUser } from '../../hooks/useGetSignedInUser';
import { getCurrentEligibleModule } from './helper';
import { EligibleModuleListSkeleton } from './pages/EligibleModuleListSkeleton';

export const EligibleModulesSkeleton: React.FC = () => {
  const { pathname } = useLocation();
  const { isFetching: isSigningIn } = useGetSignedInUser();

  const currentEligibleModule = getCurrentEligibleModule(pathname);
  return (
    <>
      <Box sx={{ mt: 5, borderBottom: 1, borderColor: 'grey.200' }} className="container-fluid">
        <Grid flexWrap="nowrap" container spacing={1}>
          {_.times(3).map((_item, index) => (
            <Grid key={index} item>
              <Skeleton
                variant="rectangular"
                sx={{ borderBottomLeftRadius: 0, borderBottomRightRadius: 0 }}
                width="7.5rem"
                height="2rem"
              />
            </Grid>
          ))}
        </Grid>
      </Box>
      <Box sx={{ display: isSigningIn ? 'none' : 'block' }}>
        <Outlet />
      </Box>
      {isSigningIn && <EligibleModuleListSkeleton module={currentEligibleModule} />}
    </>
  );
};
